(() => {
  if (!document.querySelector('.js-sofaheld-subject-card')) return;

  const deviceSize = new window.Sofatutor.Classes.DeviceSizeHelper();
  const sofaheldSubjectCards = document.querySelectorAll(
    '.js-sofaheld-subject-card'
  );

  const showLevels = e => {
    const selectedSubject = e.currentTarget.dataset.subject;

    document
      .querySelector('.sofaheld-teacher-level-selection')
      .classList.remove('is-hidden');

    document
      .querySelectorAll('.js-level-selection-headline')
      .forEach(headline => {
        headline.classList.add('is-hidden');
      });

    document
      .querySelectorAll('.js-sofaheld-level-cards')
      .forEach(card => (card.style.display = 'none'));

    document.querySelector(
      `.js-sofaheld-level-cards[data-subject="${selectedSubject}"]`
    ).style.display = 'flex';

    document
      .querySelector(
        `.js-level-selection-headline[data-subject="${selectedSubject}"]`
      )
      .classList.remove('is-hidden');
  };

  const bindEvents = () => {
    if (deviceSize.isPhone())
      sofaheldSubjectCards.forEach(card => {
        card.addEventListener('click', e => {
          // eslint-disable-next-line no-undef
          Turbolinks.visit(e.currentTarget.dataset.url, '_self');
        });
      });
    else
      sofaheldSubjectCards.forEach(card =>
        card.addEventListener('click', showLevels)
      );

    sofaheldSubjectCards.forEach(card => {
      card.addEventListener('click', e => {
        sofaheldSubjectCards.forEach(card =>
          card.classList.remove('is-active')
        );
        e.currentTarget.classList.add('is-active');
      });
    });
  };

  bindEvents();
})();
